import http from "../http-common";

const BASE = "/admin/config-sepay/token";

class SePayTokenManagementService {
  createTokenV2() {
    return http.post(`${BASE}/create/v2`);
  }

  getDetail() {
    return http.get(`${BASE}/detail`);
  }

  getAllowedIps() {
    return http.get(`${BASE}/allowed-ips`);
  }

  createIp(data) {
    return http.post(`${BASE}/allowed-ips`, data);
  }

  updateIp(id, data) {
    return http.put(`${BASE}/allowed-ips/${id}`, data);
  }

  deleteIp(id) {
    return http.delete(`${BASE}/allowed-ips/${id}`);
  }
}

export default new SePayTokenManagementService();
